import { FirebaseActions } from '@web_opxp/features';

export const welcomeBannerClickedAction = () =>
  FirebaseActions.analyticsEventAction({ eventName: 'welcome_banner_clicked' });

export const backToTrainingClickedAction = () =>
  FirebaseActions.analyticsEventAction({ eventName: 'welcome_back_to_training' });

export const feedbackTrackingAction = (feedback: 'up' | 'down') =>
  FirebaseActions.analyticsEventAction({
    eventName: 'welcome_video_feedback',
    parameters: [{ key: 'feedback', value: feedback }],
  });
